/**
 * The rail foot: who is signed in, and the Simple and Advanced switch.
 *
 * The switch lives one click from every screen on purpose. A mode switch
 * buried two clicks deep gets flipped once and forgotten, and then "two
 * artboards of the same screen" is a design fiction rather than a real user
 * behaviour. The consequence sentence is always present, never on hover.
 *
 * M1 turns the account row into the 280px popover from screen spec 2.5. In M0
 * it is the row plus the switch, both wired to real state.
 */

import { Link } from 'react-router';
import { DETAIL_TOGGLE_ENABLED, useAdvanced } from '../../lib/hooks/use-advanced';
import { useAccount } from '../../lib/auth/use-app-data';
import { t } from '../../lib/i18n/t';
import { FeedbackButton } from './FeedbackButton';

export function AccountMenu() {
  const account = useAccount();
  const [advanced, setAdvanced] = useAdvanced();

  return (
    <div className="rail__foot">
      <FeedbackButton />
      <Link className="account-row" to="/account">
        <span className="topbar__avatar" aria-hidden="true">
          {account.name.slice(0, 1)}
        </span>
        <span style={{ minWidth: 0 }}>
          <span className="account-row__name">{account.name}</span>
        </span>
      </Link>

      {DETAIL_TOGGLE_ENABLED ? (
        <>
      <div className="segmented" role="group" aria-label={t('Level of detail')}>
        <button
          type="button"
          className="segmented__option"
          aria-pressed={!advanced}
          onClick={() => setAdvanced(false)}
        >
          {t('Simple')}
        </button>
        <button
          type="button"
          className="segmented__option"
          aria-pressed={advanced}
          onClick={() => setAdvanced(true)}
        >
          {t('Advanced')}
        </button>
      </div>
      <p className="segmented__note">{t('Advanced adds technical details. It never hides anything.')}</p>
        </>
      ) : null}
    </div>
  );
}
